import Page from "../components/common/page";
import { ABOUT } from "../data/about";
import { SITE } from "../data/site";

const About = () => (
	<Page page="about" className="wrap page">
		<div className="kicker">About</div>
		<div
			style={{
				display: "flex",
				flexWrap: "wrap",
				gap: "clamp(36px, 6vw, 88px)",
				marginTop: "18px",
			}}
		>
			<div style={{ flex: "1 1 460px", minWidth: 0 }}>
				<h1 className="h-about">{ABOUT.title}</h1>
				{ABOUT.paragraphs.map((paragraph, index) => (
					<p
						key={paragraph.slice(0, 24)}
						className="p-about"
						style={index === 0 ? { marginTop: "32px" } : undefined}
					>
						{paragraph}
					</p>
				))}
			</div>
			<div style={{ flex: "0 1 320px", minWidth: "220px" }}>
				<img
					src={process.env.PUBLIC_URL + ABOUT.portrait}
					alt={ABOUT.portraitAlt}
					style={{
						width: "100%",
						height: "auto",
						filter: "grayscale(1) contrast(1.04)",
					}}
				/>
				<div
					className="secmeta"
					style={{
						fontSize: "10px",
						marginTop: "12px",
						lineHeight: 1.7,
					}}
				>
					{SITE.location}
					<br />
					{SITE.email}
				</div>
			</div>
		</div>
	</Page>
);

export default About;
